import { useState } from 'react';
import { Dropdown, DropdownContainer } from '../dropdown/dropdown';
import { ChevronDown, Proportions } from 'lucide-react';
import { Button } from '../button/button';
import { Text } from '../text/text';
import { Flex } from '../flex/flex';
import * as styles from './aspect-ratio-select.css';
import { AspectRatioOption } from './image-crop';

type AspectRatioSelectProps = {
  value: string;
  onChange: (value: string) => void;
  options: AspectRatioOption[];
};

export function AspectRatioSelect({ value, onChange, options }: AspectRatioSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const selectedOption = options.find((opt) => opt.key === value);

  return (
    <DropdownContainer onDismiss={() => setIsOpen(false)}>
      <div style={{ position: 'relative' }}>
        <Button
          onClick={() => setIsOpen(!isOpen)}
          size="xs"
          variant="secondary"
          containerStyle={{ gap: 8, alignItems: 'center' }}
        >
          <Proportions size={16} />
          <Text>{selectedOption?.label}</Text>
          <ChevronDown size={16} />
        </Button>
        <Dropdown visible={isOpen} placement="below" align="right">
          <Flex
            css={{
              minWidth: '140px',
              flexWrap: 'wrap',
              gap: '8px',
            }}
          >
            {options.map((option) => {
              const isSelected = option.key === value;
              return (
                <Button
                  variant="hollow"
                  key={option.key}
                  onClick={() => {
                    onChange(option.key);
                    setIsOpen(false);
                  }}
                  className={isSelected ? styles.optionButtonSelected : styles.optionButton}
                  data-selected={isSelected}
                >
                  {option.label}
                </Button>
              );
            })}
          </Flex>
        </Dropdown>
      </div>
    </DropdownContainer>
  );
}
